import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
	name: 'formErrors',
	standalone: true
})
export class FormErrorsPipe implements PipeTransform {
	transform(control: ValidationErrors | null): string {
		if (!control) return '';

		const errorType = Object.keys(control)[0];

		switch (errorType) {
			case 'required':
				return 'Este campo es obligatorio';

			case 'minlength':
				return `Debe ingresar al menos ${control['minlength'].requiredLength} caracteres`;

			case 'maxlength':
				return `Debe ingresar como máximo ${control['maxlength'].requiredLength} caracteres`;

			case 'pattern':
				return 'El valor ingresado no cumple con el formato solicitado';

			case 'email':
				return 'Debe ingresar un correo electrónico válido';

			case 'menorEdad':
				return 'El usuario debe ser mayor de edad';

			case 'muyAntigua':
				return 'La fecha de nacimiento no puede ser mayor a 110 años atrás';

			case 'min':
				return 'El valor ingresado es menor al permitido';

			case 'max':
				return 'El valor ingresado es mayor al permitido';

			default:
				return 'Debe ingresar un valor válido';
		}
	}
}
